module.exports = __webpack_public_path__ + "img/9视觉设计.814f5a17.png";